<template>
  <Modal :title="title" :showModal="true" class="edit-order-form" @submit="submit">
    <template v-slot:body>
      <div class="position-relative form-group">
        <label class="col-12 mb-0 p-0">Label</label>
        <input class="form-control mt-2" type="text" :value="changed.label ?? data.label" @change="changed.label = $event.target.value" />
      </div>
      <div class="position-relative form-group">
        <label class="col-12 mb-0 p-0">Description</label>
        <textarea class="form-control mt-2" :value="changed.description ?? data.description" @change="changed.description = $event.target.value" />
      </div>
    </template>
  </Modal>
</template>

<script>
export default {
  name: 'Total Sale',
  grid: {
    minW: 4
  },
  data() {
    return {
      changed: {}
    }
  },
  computed: {
    title() {
      return 'Total Sale'
    },
    storeId() {
      return this.config?.storeId
    },
    data() {
      return this.config?.data || {}
    }
  },
  methods: {
    submit() {
      let data = Object.assign({}, this.data, this.changed)
      if (this.config?.callback) this.config?.callback({ index: this.config?.index, data })
      this.$emit('close')
    }
  },
  props: {
    config: Object
  }
}
</script>
